module.exports = __webpack_public_path__ + "a7c132f2df54a7601dabb58cfd6e67aa.pdf";